var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 35,
    viewBox: "0 0 200 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_26873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.78 30.1888C15.78 28.4354 14.7318 26.8535 13.1308 26.1484C9.58596 24.6046 7.10835 21.0598 7.10835 16.9431C7.10835 12.8265 9.58596 9.30066 13.1308 7.73786C14.7318 7.0327 15.78 5.45084 15.78 3.69746V-0.133301C6.95588 0.552806 -0.0195312 7.96657 -0.0195312 16.9622C-0.0195312 25.9578 6.95588 33.3716 15.78 34.0577V30.1888Z",
    fill: "url(#paint0_linear_579_26873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6104 -0.133301V3.71652C19.6104 5.4699 20.6586 7.05176 22.2785 7.75692C25.8425 9.30066 28.3391 12.8455 28.3391 16.9622C28.3391 21.0788 25.8425 24.6237 22.2785 26.1674C20.6586 26.8726 19.6104 28.4545 19.6104 30.2078V34.0577C28.4535 33.3906 35.448 25.9769 35.448 16.9622C35.448 7.94751 28.4535 0.533747 19.6104 -0.133301Z",
    fill: "url(#paint1_linear_579_26873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4874 6.82324H65.79V26.949H69.4874V6.82324Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.918 23.3279V6.82324H186.221V26.949H200.076V23.3279H189.918Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6821 10.5015V6.82324H46.8838V26.949H50.5621V19.0969H58.8335V15.552H50.5621V10.5015H60.6821Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.289 6.82324V15.0565H97.9796V6.82324H94.2822V26.949H97.9796V18.6776H106.289V26.949H109.986V6.82324H106.289Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.443 26.949C127.215 26.949 128.778 26.3963 129.96 25.3672C131.103 24.3571 131.77 22.9467 131.77 21.5173V20.2976C131.77 19.0207 131.218 17.7247 130.265 16.7527C130.208 16.6955 130.15 16.6384 130.093 16.5812C130.894 15.6473 131.351 14.4847 131.351 13.3031V12.1977C131.351 10.9208 130.798 9.62483 129.846 8.65284C129.045 7.83333 127.539 6.84229 125.024 6.84229H116.314V26.9681L125.443 26.949ZM120.011 23.2517V18.6395H125.443C128.054 18.6395 128.073 20.2976 128.073 20.3167V21.5173C128.073 22.2416 127.254 23.2517 125.443 23.2517H120.011ZM120.011 15.0946V10.5015H125.024C127.635 10.5015 127.654 12.1596 127.654 12.1787V13.2841C127.654 14.0083 126.834 15.0946 125.024 15.0946H120.011Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.141 27.1014H144.711C142.786 27.1014 140.633 26.2056 138.994 24.7C137.069 22.9657 136.021 20.6024 136.021 18.0677V15.6853C136.021 13.1506 137.069 10.8064 138.994 9.05298C140.652 7.54736 142.786 6.65161 144.711 6.65161H146.141C148.065 6.65161 150.219 7.54736 151.877 9.05298C153.802 10.7873 154.85 13.1506 154.85 15.6853V18.0867C154.85 20.6215 153.802 22.9657 151.877 24.7191C150.2 26.2056 148.065 27.1014 146.141 27.1014ZM144.711 10.349C142.958 10.349 139.699 12.1786 139.699 15.6663V18.0677C139.699 21.5554 142.958 23.385 144.711 23.385H146.141C147.894 23.385 151.153 21.5554 151.153 18.0677V15.6853C151.153 12.1976 147.894 10.368 146.141 10.368H144.711V10.349Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4189 27.0251H81.0557C77.7776 27.0251 75.3762 25.0621 74.4614 21.6125L78.0254 20.6596C78.6543 23.0229 79.9693 23.3278 81.0557 23.3278H83.4189C84.3909 23.3278 85.1532 22.9847 85.5535 22.3558C85.9156 21.765 85.9537 21.0217 85.6297 20.3356C85.1151 19.2493 83.0187 18.7156 80.7888 18.1248C80.0456 17.9342 79.2832 17.7246 78.4828 17.4959C75.967 16.7526 74.4995 14.3322 74.8807 11.6449C75.2428 9.26261 77.244 6.67065 80.8079 6.67065H82.79C84.429 6.67065 85.9156 7.18523 87.0782 8.15722C88.1073 9.01485 88.8125 10.2155 89.0793 11.4925L85.4582 12.2357C85.4201 12.0452 85.0008 10.368 82.79 10.368H80.8079C78.9021 10.368 78.5971 11.9117 78.5399 12.2167C78.4828 12.5407 78.4256 13.6651 79.531 13.9891C80.2552 14.1988 80.9985 14.3894 81.7037 14.5799C84.6577 15.3423 87.7071 16.1427 88.9649 18.7728C89.8226 20.6024 89.7273 22.6798 88.66 24.3379C87.5927 26.0532 85.6678 27.0251 83.4189 27.0251Z",
    fill: "#192229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.339 6.82324L174.5 18.4108L171.069 6.82324H167.962L164.532 18.4108L161.711 6.82324H157.709L162.607 26.949H165.809L169.525 14.3704L173.242 26.949H176.424L181.322 6.82324H177.339Z",
    fill: "#192229"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_579_26873",
    x1: 7.88123,
    y1: 1.55515,
    x2: 7.88123,
    y2: 25.2653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00162595,
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    stopColor: "#0029F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_579_26873",
    x1: 27.5302,
    y1: 1.55515,
    x2: 27.5302,
    y2: 25.2653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00162595,
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    stopColor: "#0029F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_26873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 34.0194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveLogoHorizontal);
export default __webpack_public_path__ + "static/media/drive-logo-horizontal.3320515b2f7176a531fab0b3c609e461.svg";
export { ForwardRef as ReactComponent };